import { API } from 'aws-amplify';
import { requestOptions } from '../constants';
import {
  ADD_GEOHASH_GROUP,
  REMOVE_GEOHASH_GROUP,
  MISSION_CREATED,
  API_DATA_REQUESTED,
  API_ERROR,
  QUEUE_NOTIFICATION,
  ADD_TUPLE_LIST,
} from './actionTypes';

const options = requestOptions;

export const addGeohashGroup = (name, list, color, heightFromGround, cuboidHeight) => (dispatch) => {
  dispatch({
    type: ADD_GEOHASH_GROUP,
    payload: {
      name,
      list,
      color,
      heightFromGround,
      cuboidHeight,
    },
  });
};

export const addTupleList = (name, tupleList) => (dispatch) => {
  dispatch({
    type: ADD_TUPLE_LIST,
    payload: {
      name,
      tupleList,
    },
  });
};

export const removeGeohashGroup = (id) => (dispatch) => {
  dispatch({
    type: REMOVE_GEOHASH_GROUP,
    payload: id,
  });
};

export const createMission = (basket, geoJson) => (dispatch) => {
  dispatch({ type: API_DATA_REQUESTED });

  const body = {
    orderBasket: basket,
    geoJson
  };

  API.post('api', '/dev/ordermission', { body }, options)
    .then((res) => {
      dispatch({
        type: MISSION_CREATED,
        payload: res,
      });

      dispatch({
        type: QUEUE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Mission '${res.order.id}' create successfuly`
        }
      });
    })
    .catch((err) => {
      dispatch({
        type: API_ERROR,
        payload: err,
      });
    });
};